var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFailedPayment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8438 2.19375C9.91875 -0.73125 5.11875 -0.73125 2.19375 2.19375C-0.73125 5.11875 -0.73125 9.91875 2.19375 12.8438C5.11875 15.7688 9.84375 15.7688 12.7687 12.8438C15.6937 9.91875 15.7688 5.11875 12.8438 2.19375ZM9.61875 10.6688L7.51875 8.56875L5.41875 10.6688L4.36875 9.61875L6.46875 7.51875L4.36875 5.41875L5.41875 4.36875L7.51875 6.46875L9.61875 4.36875L10.6688 5.41875L8.56875 7.51875L10.6688 9.61875L9.61875 10.6688Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedPayment);
export default __webpack_public_path__ + "static/media/failed-payment.b69067adc13230db0ad1b47f7cf0c0fe.svg";
export { ForwardRef as ReactComponent };